import React from "react";

/**
 * Status configuration for each payment tier.
 * Returns label and display text used across the app (badges, billing section, etc.)
 */
export const getStatusConfig = (status) => {
  switch (status) {
    case "paid":
      return {
        label: "Pro",
        planName: "Current Plan",
        bgColor: "rgba(59,130,246,0.12)",
        textColor: "#3b82f6",
      };
    case "org":
      return {
        label: "Pro",
        planName: "Current Plan",
        bgColor: "rgba(59,130,246,0.12)",
        textColor: "#3b82f6",
      };
    case "trial":
      return {
        label: "Pro Trial",
        planName: "Pro Trial",
        bgColor: "rgba(59,130,246,0.12)",
        textColor: "#3b82f6",
      };
    case "free":
    default:
      return {
        label: "Free",
        planName: "Free Plan",
        bgColor: "rgba(156,163,175,0.15)",
        textColor: "#9ca3af",
      };
  }
};

/**
 * Reusable status badge component.
 * Displays a pill-shaped badge reflecting the user's payment tier.
 * Used in: sidebar header, profile dropdown, account page, billing modal.
 */
const StatusBadge = ({ paymentStatus, style = {} }) => {
  const config = getStatusConfig(paymentStatus);

  return (
    <span
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
        padding: "3px 10px",
        borderRadius: "14px",
        fontSize: "11px",
        fontWeight: 600,
        flexShrink: 0,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
